import React from 'react';

const ImagePreview = ({ url }) => {
  return <img src={url} />;
};

export default ImagePreview;
